
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import { OperationInfo, PermissionCode } from '@/types';
import { currentUserHasPermission } from '@/helpers';
import OperationNotesDialog from '@/components/OperationNotesDialog.vue';

@Component({
  components: {
    OperationNotesDialog,
  },
})
export default class LeadOpNotesIcon extends Vue {
  @Prop(Object) readonly operationInfo: OperationInfo | undefined;

  operationNotesDialog = false

  loading = false

  @Watch('operationNotesDialog')
  onOperationNotesDialogChange(val: boolean) {
    // Se è stato chiuso il dialog...
    if (val === false) {
      // ... emette l'evento "close"
      this.$emit('close');
    }
  }

  get hasOpNotes(): boolean {
    return this.operationInfo?.hasOpNotes === true;
  }

  get iconColor(): string {
    return this.hasOpNotes ? 'orange' : 'grey';
  }

  get tooltipText(): string {
    if (this.hasPermission('taskcm.notes.edit')) {
      // L'utente ha il permesso per modificare le note
      return this.hasOpNotes
        ? 'Mostra o modifica le note commessa'
        : 'Non ci sono note commessa';
    }

    if (this.hasPermission('taskcm.notes.show')) {
      // L'utente ha il permesso per mostrare le note
      return this.hasOpNotes
        ? 'Mostra le note commessa'
        : 'Non ci sono note commessa';
    }

    return 'Note commessa';
  }

  hasPermission(codename: PermissionCode): boolean { return currentUserHasPermission(codename); }

  async onShow() {
    console.log(`${this.constructor.name}: onShow()`); // eslint-disable-line no-console

    // Se l'utente non ha il permesso per mostrare o modificare, si ferma.
    if (!this.hasPermission('taskcm.notes.edit') && !this.hasPermission('taskcm.notes.show')) return;

    if (this.operationInfo) {
      // Seleziona la Lead corrispondente alla commessa prima di aprire il dialog
      this.loading = true;
      await this.$store.dispatch('selectLead', { id: this.operationInfo.id });
      this.operationNotesDialog = true;
      this.loading = false;
    }
  }
}
